import apiBaseUrl from '../../utils/config.js';

class ReceiptAPI {
  constructor() {
    this.baseUrl = `${apiBaseUrl}/receipts`;
  }

  getToken() {
    return localStorage.getItem("jwt");
  }

  getAuthHeaders() {
    const token = this.getToken();
    return {
      'Content-Type': 'application/json',
      ...(token && { Authorization: `Bearer ${token}` }),
    };
  }

  async #request(endpoint = '', method = 'GET', body = null) {
    const options = {
      method,
      headers: this.getAuthHeaders(),
    };

    if (body) {
      options.body = JSON.stringify(body);
    }

    try {
      const res = await fetch(`${this.baseUrl}${endpoint}`, options);
      if (!res.ok) {
        const errorText = await res.text();
        throw new Error(errorText || 'Request failed');
      }

      return res.headers.get('Content-Type')?.includes('application/json')
        ? await res.json()
        : await res.text();
    } catch (error) {
      console.error(`Error in ${method} ${endpoint}:`, error);
      throw error;
    }
  }

  // Get all receipts
  async getAll() {
    return this.#request();
  }

  // Get receipt by ID
  async getById(id) {
    return this.#request(`/${id}`);
  }

  // Get receipts by pointsBankId
  async getByPointsBankId(pointsBankId) {
    return this.#request(`/pointsBank/${pointsBankId}`);
  }

  // Get receipts by inventoryId
  async getByInventoryId(inventoryId) {
    return this.#request(`/inventory/${inventoryId}`);
  }

  // Get receipts by date (yyyy-MM-dd)
  async getByDate(dateStr) {
    return this.#request(`/date/${dateStr}`);
  }

  // Add a new receipt
  async add(receipt) {
    return this.#request('', 'POST', receipt);
  }

  // Update a receipt
  async update(id, receipt) {
    return this.#request(`/${id}`, 'PUT', receipt);
  }

  // Delete a receipt
  async delete(id) {
    return this.#request(`/${id}`, 'DELETE');
  }
}

export default ReceiptAPI;
